import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { addListEmployeeAction } from '@/redux/actions/employee';
import { addListEmployee, TAddListEmployeeResponse } from '@/services/api/employee';
import { checkAccessToken } from '@/utils/handle-authentication';
import { handleAPIError } from '@/utils/handle-api-error';

// FUNCTION
export function* addListEmployeeSaga(action: ActionType<typeof addListEmployeeAction.request>): Generator {
  const { materials, companyId, successCallback, failedCallback } = action.payload;
  try {
    yield call(checkAccessToken);
    const response = yield call(addListEmployee, materials, companyId);
    const addListEmployeeResponse: TAddListEmployeeResponse = response as TAddListEmployeeResponse;
    yield put(addListEmployeeAction.success(addListEmployeeResponse));
    successCallback?.(addListEmployeeResponse);
  } catch (err) {
    yield put(addListEmployeeAction.failure(err));
    failedCallback?.(err);
    handleAPIError(err, 'Error.addListEmployeeError');
  }
}
